import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-agris-coriz-perder-dialog',
  templateUrl: './agris-coriz-perder-dialog.component.html',
  styleUrls: ['./agris-coriz-perder-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisCorizPerderDialogComponent implements OnInit {

  obs = '';
  err = false;

  constructor(
    private dialogRef: MdDialogRef<AgrisCorizPerderDialogComponent>
  ) { }

  ngOnInit() {
  }

  onSubmit() {
    if (!this.obs.trim().length) {
      this.err = true;
    } else {
      this.dialogRef.close(this.obs.trim());
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-coriz-perder-dialog/agris-coriz-perder-dialog.component.ts